import { http } from './http';

export function submitSimilarSuggestion(category, baseId, payload) {
  return http
    .post(`/api/v1/media/${category}/${baseId}/similar-suggestions`, payload)
    .then((r) => r.data);
}
